/**
 * Inject Clean & Box PDP type-scale CSS (silk-matched body size + FAQ body font).
 * Loads section-mdb-pdp-type-v2.css (new filename for Shopify sync).
 */
(function () {
  if (document.getElementById('mdb-pdp-type-boot')) return;
  var sample = document.querySelector(
    'link[href*="/cdn/shop/t/"][href*="/assets/"], script[src*="/cdn/shop/t/"][src*="/assets/"]'
  );
  var href = '/cdn/shop/t/28/assets/section-mdb-pdp-type-v2.css';
  if (sample) {
    href = (sample.href || sample.src).replace(/\/assets\/[^/?#]+.*/, '/assets/section-mdb-pdp-type-v2.css');
  }
  var link = document.createElement('link');
  link.id = 'mdb-pdp-type-boot';
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
})();
